import { gql } from '@apollo/client';

export const QUERY_BRAZIL_POLYGONS = gql`
  query BrazilPolygons($quality: GeometryQuality!) {
    brazil_polygons(quality: $quality) {
      municipality_code
      geometry
    }
  }
`;
